<template>
  <div>
    <modal
      class="new-modal-default v--modal-overlay"
      :name="modal_name"
      transition="nice-modal-fade"
      :delay="100"
      height="auto"
      :max-height="170"
      :min-width="600"
      :pivot-y="0.5"
      :adaptive="true"
      :scrollable="true"
      style="border-radius: 7.5px; pointer-events:inherit !important" 
      v-bind:click-to-close="false"
    >
      <div
        class="v-modal-content d-flex flex-column justify-content-center align-items-center text-center"
        style="background-color: #ffffff !important"
      >
        <div
          class="w-100 bg-secondary d-flex align-items-center justify-content-center text-white"
          style="height: 50px"
        >
          <p class="text-center mt-2 fw-500" style="font-size: 16px">
            INVITE TO CONNECT
          </p>
          <div>
            <span
              class="icon icon-close mr-2 mb-1 text-white pointer close-left"
              @click="hideSelf"
            ></span>
          </div>
        </div>
        <div class="my-7 text-center w-100">
          <p>
            You can add a note to personalize your invitation to {{ user_name }}
          </p>
        </div>
        <div class="d-flex aligin-items-center justify-content-center mb-6">
          <button
            type="button"
            class="btn mx-5 btn-xlg text-secondary"
            style="
              box-shadow: none;

              background-color: white;
              border: 1px solid #00448b;
            "
            @click="AddNote"
          >
            Add a Note
          </button>
          <button
            type="button"
            class="btn btn-new-primary btn-xlg"
            style="box-shadow: none;"
            @click="sendRequest"
          >
            Send Request
          </button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
export default {
  props: ["modal_name", "user_name"],
  methods: {
    hideSelf() {
      this.$modal.hide(this.modal_name);
    },
    sendRequest() {
      this.$modal.hide(this.modal_name);
      this.$emit("sendRequest");
    },
    AddNote() {
      this.$modal.hide(this.modal_name);
      this.$emit("AddNote");
    },
  },
};
</script>
<style scoped>
.btn-xlg {
  text-transform: none !important;
  border-radius: 6px;
   width:130px;
}
</style>


// WEBPACK FOOTER //
// src/components/alertModals/Connect.vue